import isClient from './util/detectClient';
import request from './util/request';
import configurable from './util/configurable';
import {getUserID, Config, trackID} from './util/config';
import {camelToUnder} from './util/json';

export const ERROR_TYPE = {
    // 静态文件
    STATIC_RESPOURSE: 1,
    // js报错
    JAVASCRIPT: 2,
    // 接口请求
    HTTP_REQUEST: 3,
    // 白屏
    PAGE_BLANK: 4,
    // 业务自定义报错
    BUSINESS: 5,
};

export const ERROR_LEVEL = {
    // 紧急
    URGENT: 1,
    // 严重
    CRITICAL: 2,
    // 轻微
    MINIMAL: 3,
};

const DEFAULT_ERROR_EVENT_ID = '8695928043431936';

/**
 * 错误上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */
const report = configurable((json, callback) => {
    const {
        url = isClient ? location.href : '',
        path = isClient ? location.pathname : '',
        event_id = DEFAULT_ERROR_EVENT_ID,
        uid = getUserID(),
        track_id = trackID,
        error_type,
        error_level,
        error_description,
        error_extra,
        ...rest
    } = camelToUnder(json);

    // 要上报的数据
    const errorData = {
        // 当前页面 URL
        url,

        path,

        // 登录用户 ID，用户登录后端写到 cookie 中
        uid,

        event_id,

        // 错误类型
        error_type,

        // 错误等级
        error_level,

        // 错误描述
        error_description,

        // 其他信息
        error_extra,

        track_id,

        ...rest,
    };

    request(Config.VERB)(`${Config.GS}`, errorData, callback);
}, {});

export default report;
